import { IAttachment } from '@/app/attachments/shared/idea-attachment.model';
import { IDictionary } from 'src/app/shared/interfaces/models/idictionary.model';

export interface IIdeaField extends IDictionary {
  BusinessFunctionId?: number;
  TypeId?: number;
  TagId?: number;
  Description?: string;
  IsRequired?: boolean;
  IsShowInList?: boolean;
  IsShowInForm?: boolean;
  IsShowInFilter?: boolean;
  IsHeader?: boolean;
  IsShowInCondition?: boolean;
  Order?: number;
  Color?: string;
  Config?: IdeaFieldConfig;
  TemplateAttachmentId?: string;
  Attachment?: IAttachment;
  Example?: string;
  Hints?: string;
  StepId?: number;
}

export interface IdeaFieldConfig {
  ValueTypeId?: number;
  MaxAttachments?: number;
  Values?: OptionValue[];
}

export interface OptionValue {
  Id?: string;
  Order?: number;
  Title: string;
  Value: string;
  Description?: string;
  IsHide?: boolean;
  IsDisabled?: boolean;
  Children?: OptionValue[];
}

export function sortOptionValues(values: OptionValue[] = []): OptionValue[] {
  return [...values]
    .sort((a, b) => (a.Order ?? 0) - (b.Order ?? 0))
    .map((v) => ({
      ...v,
      Children: v.Children?.length ? sortOptionValues(v.Children) : v.Children,
    }));
}

/** Плоский список всех вариантов, включая вложенные Children (без учёта уровня). */
export function flattenOptionValues(values: OptionValue[] = []): OptionValue[] {
  const result: OptionValue[] = [];
  for (const value of sortOptionValues(values)) {
    if (!value.IsHide) {
      result.push(value);
    }
    if (value.Children?.length) {
      result.push(...flattenOptionValues(value.Children));
    }
  }
  return result;
}
